import clsx from 'clsx'
import { isAstrologyHost } from 'config/flags'
import { FC, ReactNode } from 'react'

import styles from './styles.module.scss'

type Props = {
  children: ReactNode
  className?: string
}

const PageWrapper: FC<Props> = ({ children, className }) => {
  return <div className={clsx(styles.wrapper, className, isAstrologyHost && 'app_astro_theme')}>{children}</div>
}

export default PageWrapper
